<template>
  <div class="p-4">
    <h3 class="font-semibold text-2xl">Add Card</h3>
    <span>Add debit card</span>

    <div class="flex flex-wrap">
      <div class="col-md-6 col-12 mid-card-field my-5">
        <label>Card Number</label>
        <div class="bg-gray-100 p-3 flex items-center ">
          <input
            class="bg-transparent w-full"
            placeholder="4960 0922 9135 2659"
            type="text"
            @input="reformNumber"
            v-model="cardNumber"
          />
          <span
            >
            <component :is="checkCardType"></component>
          </span>
        </div>
      </div>
      <div class="col-md-6 col-12 mid-card-field my-5"></div>
      <div class="col-md-6 col-12 mid-card-field my-5">
        <label>Expiry Date</label>
        <div class="bg-gray-100 p-3 flex items-center ">
          <input
            maxlength="5"
            class="bg-transparent w-full"
            placeholder="_ _  / _ _"
            @input="reformExpDate"
            v-model="cardDetails.expDate"
            type="text"
          />
        </div>
      </div>

      <div class="col-md-6 col-12 mid-card-field my-5">
        <label>CVV</label>
        <div class="bg-gray-100 p-3 flex items-center ">
          <input
            maxlength="4"
            type="number"
            class="bg-transparent w-full"
            placeholder="Enter"
          />
        </div>
      </div>
      <div class="flex justify-end items-center w-full mb-4 pr-3">
        <div><el-switch v-model="isDefault" /> Set as default for payments</div>
      </div>


      <div class="divider"></div>
    </div>

    <div class="w-full flex justify-between pt-4">
      <button @click="$router.go(-1)">cancel</button>
      <button class="px-4 py-2 bg-primary-yellow" @click="createCard">
        Save
      </button>
    </div>
    <ConfirmCardCode
      :show-modal="showCardCode"
      @close-modal="showCardCode = false"
    />
  </div>
</template>

<script>
import ConfirmCardCode from "./modals/ConfirmCardCodeModal.vue";
import Visa from "../../../assets/images/ondemand/visa.vue";
import Eye from "../../../assets/images/billing/eye.vue";
import { userId } from "../../../services/apiConfig";
import MastercardIcon from "../../../assets/images/ondemand/MastercardIcon.vue";
import VerveIcon from "../../../assets/images/ondemand/VerveIcon.vue";


export default {
  components: {
    ConfirmCardCode,
    Visa,
    Eye,
    MastercardIcon,
    VerveIcon
  },
  data() {
    return {
      showCardCode: false,
      wallet: "",
      isDefault: false,
      cardNumber: "",
      cardDetails: {
        expDate: "",
        cardNumber: "",
      },
    };
  },
  computed: {
    payload() {
      return {
        userId: userId(),
        cardNumber: this.cardNumber.trim(),
        cardType: "visa",
        isDefault: this.isDefault,
      };
    },
    checkCardType() {
      // Visa
      let visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;
      if (visaRegex.test(this.cardNumber.replace(/\s+/g, ''))) {
        return "visa";
      }

      // Mastercard
      let mastercardRegex = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
      if (mastercardRegex.test(this.cardNumber.replace(/\s+/g, ''))) {
        return "mastercard-icon";
      }

      // Verve
      let verveRegex = /^(50[0-9]{14}|60[0-9]{14}|601[1-9][0-9]{11}|6011[0-9]{11}|65[0-9]{14}|30[0-9]{11})$/;
      if (verveRegex.test(this.cardNumber.replace(/\s+/g, ''))) {
        return "verve-icon";
      }
      return null;
    },
  },
  
  methods: {
    async createCard() {
      try {
        await this.$_createCard(this.payload);
        this.$router.push({
          name: "AccountStatement",
          params: { name: "view-cards" },
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    reformExpDate(e) {
      let exp = e.target.value;
      const expDateFormatter = exp.replace(/\//g, "").substring(0, 2) + 
      (exp.length > 2 ? '/' : '') + 
       exp.replace(/\//g, "").substring(2, 4);
       
      this.cardDetails.expDate = expDateFormatter;
    },
    reformNumber(e) {
      let value = e.target.value;
      if (value.length > 19)
        this.cardNumber = value.substring(0, 19);
      else {
        let splitCardNumber = value
          .replace(/\s+/g, "")
          .match(/.{1,4}/g)
          .join(" ");
        this.cardNumber = splitCardNumber;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mid-card-field {
  label {
    @apply w-full block;
  }
}
.divider {
  border-width: 1px;
  @apply w-full border-gray-300;
}
</style>
